import React from 'react'

const Shopping = props => {

  return (
    <svg
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9603 21.9999H11.4811C9.16033 21.9999 8.75562 20.8743 8.75562 18.5156V14.772C8.75562 12.4132 9.16665 11.2876 11.4811 11.2876H20.9603C23.281 11.2876 23.6858 12.4132 23.6858 14.772V18.5156C23.6858 20.8743 23.2747 21.9999 20.9603 21.9999ZM11.4811 12.7168C10.3745 12.7168 10.1784 12.7168 10.1784 14.7783V18.5219C10.1784 20.5834 10.3745 20.5834 11.4811 20.5834H20.9603C22.0669 20.5834 22.2629 20.5834 22.2629 18.5219V14.7783C22.2629 12.7168 22.0669 12.7168 20.9603 12.7168H11.4811Z"
        fill={props.color}
      />
      <path
        d="M6.15751 17.7822H4.36791C1.22506 17.7822 0.314453 16.8273 0.314453 13.539V8.77099C0.314453 5.48901 1.22506 4.54047 4.36791 4.54047H15.4217C18.3874 4.54047 19.3739 5.42578 19.4688 8.18289C19.4814 8.57495 19.1779 8.90378 18.7858 8.91643C18.3938 8.94173 18.0649 8.62554 18.0523 8.23348C17.9827 6.24153 17.6665 5.96329 15.428 5.96329H4.36791C2.00919 5.96329 1.73727 6.25418 1.73727 8.77731V13.5453C1.73727 16.0685 2.00919 16.3594 4.36791 16.3594H6.15751C6.54957 16.3594 6.86575 16.6755 6.86575 17.0676C6.86575 17.4597 6.54957 17.7759 6.15751 17.7759V17.7822Z"
        fill={props.color}
      />
      <path
        d="M12.8413 9.75739C12.4493 9.75739 12.1331 9.44121 12.1331 9.04914V3.56021C12.1331 2.0868 11.0075 1.42282 9.8882 1.42282C8.76891 1.42282 7.6433 2.08048 7.6433 3.56021V9.04914C7.6433 9.44121 7.32712 9.75739 6.93506 9.75739C6.54299 9.75739 6.22681 9.44121 6.22681 9.04914V3.56021C6.22681 1.22046 8.07331 0 9.89452 0C11.7157 0 13.5622 1.22046 13.5622 3.56021V9.04914C13.5622 9.44121 13.2461 9.75739 12.854 9.75739H12.8413Z"
        fill={props.color}
      />
      <path
        d="M16.2175 17.0422C15.25 17.0422 14.3457 16.6564 13.6691 15.9545C12.9355 15.1894 12.5498 14.1143 12.5498 12.8496C12.5498 12.4575 12.866 12.1414 13.2581 12.1414C13.6501 12.1414 13.9663 12.4575 13.9663 12.8496C13.9663 14.7657 15.0919 15.6194 16.2112 15.6194C17.3305 15.6194 18.4561 14.7657 18.4561 12.8496C18.4561 12.4575 18.7723 12.1414 19.1643 12.1414C19.5564 12.1414 19.8726 12.4575 19.8726 12.8496C19.8726 15.6004 18.0261 17.0422 16.2049 17.0422H16.2175Z"
        fill={props.color}
      />
    </svg>
  );
}

export {Shopping};
